import styled from "@emotion/styled";
import { rem } from "polished";

import { colors } from "../../design-tokens/colors";
import { globalContentMaxWidth, sizes } from "../../design-tokens/dimensions";
import { borderRadii } from "../../design-tokens/effects";
import { typography } from "../../design-tokens/typography";

export const Root = styled.table<{
  $isBordered: boolean;
  $isStriped: boolean;
  $isHeaderHighlighted: boolean;
}>`
  background: ${colors.blueDeep};
  border: ${({ $isBordered }) => ($isBordered ? `${rem(1)} solid ${colors.betaBase}` : "none")};
  border-collapse: collapse;
  border-radius: ${borderRadii.r8};
  font-size: ${typography.sizes["16"]};
  letter-spacing: ${typography.letterSpacing["3"]};
  line-height: ${typography.lineHeights["24"]};
  margin: 0 auto;
  max-width: ${rem(globalContentMaxWidth)};
  text-align: left;
  width: 100%;

  thead,
  tfoot,
  th {
    font-weight: ${typography.weights.bold};
  }

  tr {
    border-bottom: ${rem(1)} solid ${colors.betaBase};
    height: ${sizes.s48.rem};
  }

  thead tr {
    background: ${({ $isHeaderHighlighted }) =>
      $isHeaderHighlighted ? colors.baseMid : "transparent"};
  }

  tbody tr:nth-child(odd) {
    background: ${({ $isStriped }) => ($isStriped ? colors.baseDark : "transparent")};
  }

  tfoot tr {
    background: ${({ $isHeaderHighlighted }) =>
      $isHeaderHighlighted ? colors.baseMid : "transparent"};
    &:last-child {
      border-bottom: none;
    }
  }

  td,
  th {
    border-left: ${({ $isBordered }) =>
      $isBordered ? `${rem(1)} solid ${colors.betaBase}` : "none"};
    border-right: ${({ $isBordered }) =>
      $isBordered ? `${rem(1)} solid ${colors.betaBase}` : "none"};
    padding: ${sizes.s12.rem};
  }

  caption {
    caption-side: bottom;
    font-style: italic;
    padding: ${sizes.s8.rem};
  }
`;
